var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 32,
    viewBox: "0 0 17 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3285 5.31333H16.2498V0.225333C15.7458 0.156 14.0125 0 11.9938 0C7.78181 0 4.89647 2.64933 4.89647 7.51867V12H0.248474V17.688H4.89647V32H10.5951V17.6893H15.0551L15.7631 12.0013H10.5938V8.08267C10.5951 6.43867 11.0378 5.31333 13.3285 5.31333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookActive);
export default __webpack_public_path__ + "static/media/facebook-active.d2f737c5.svg";
export { ForwardRef as ReactComponent };